import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCalendarXmark, faCalendar, faListCheck, faCashRegister, faMoneyCheckAlt, 
    faPiggyBank, faCarrot, faBookOpen, faCalendarAlt, faSeedling, faAsterisk, faGifts, 
    faUtensils, faCloudMoon, faSuitcase, faCar, faTrash, faFolder, faUserCheck, 
    faSyringe, faHandHoldingHeart, faHeart, faClipboardList, faFileArchive, faFamily, 
    faUsers, faHeart as faHeartSolid,
    faCameraRetro,
    faFaceSmile,
    faFaceGrinHearts,
    faDog,
    faCat,
    faHorse,
    faCow,
    faDove,
    faCalendarCheck,
    faFeatherAlt,
    faPenFancy,
    faGaugeHigh,
    faPersonBurst,
    faMobile,
    faKitMedical,
    faShoppingBasket
} from '@fortawesome/free-solid-svg-icons';
import './AssociationsHome.css';
import lifechroniclesimage from '../../assets/pageimages/LifeChronicle.webp';

const categories = [
    { to: "/chronicle-calendar", icon: faCalendarXmark, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/chronicle-planner", icon: faCalendar, label: "Planner", bgColor: "bg-teal-500", textColor: "text-white" },
    { to: "/chronicle-todo", icon: faListCheck, label: "Checklist", bgColor: "bg-purple-500", textColor: "text-white" },
    { to: "/mypetty-account", icon: faCashRegister, label: "Petty Account", bgColor: "bg-yellow-600", textColor: "text-white" },
    { to: "/myloans", icon: faMoneyCheckAlt, label: "Loans", bgColor: "bg-blue-600", textColor: "text-white" },
    { to: "/myassets", icon: faPiggyBank, label: "Assets", bgColor: "bg-green-600", textColor: "text-white" },
    { to: "/myinvestments", icon: faPiggyBank, label: "Investments", bgColor: "bg-green-700", textColor: "text-white" },
    { to: "/myroutines-diet", icon: faCarrot, label: "Diet Routine", bgColor: "bg-orange-500", textColor: "text-white" },
    { to: "/myroutines-study", icon: faBookOpen, label: "Study Routine", bgColor: "bg-blue-500", textColor: "text-white" },
    { to: "/myroutines-others", icon: faCalendarAlt, label: "Other Routines", bgColor: "bg-pink-500", textColor: "text-white" },
    { to: "/tasks-list", icon: faAsterisk, label: "Tasks", bgColor: "bg-gray-700", textColor: "text-white" },
    { to: "/gift-list", icon: faGifts, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
    { to: "/checklist", icon: faUtensils, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-orange-600", textColor: "text-white" },
    { to: "/digital-time-list", icon: faMobile, label: "Digital Time", bgColor: "bg-gray-600", textColor: "text-white" },

    { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/events-list", icon: faCalendar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
    { to: "/gardening-list", icon: faSeedling, label: "Gardening", bgColor: "bg-green-500", textColor: "text-white" },
    { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-pink-600", textColor: "text-white" },
    { to: "/environment-list", icon: faHeartSolid, label: "Environment / Sustainability", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/exercise-list", icon: faSuitcase, label: "Gym/Yoga/Exercise", bgColor: "bg-red-600", textColor: "text-white" },
    { to: "/experiences-list", icon: faHeartSolid, label: "Experience", bgColor: "bg-indigo-700", textColor: "text-white" },
    { to: "/feelings-list", icon: faHeartSolid, label: "Feelings", bgColor: "bg-pink-600", textColor: "text-white" },
    { to: "/food-list", icon: faUtensils, label: "Food", bgColor: "bg-yellow-700", textColor: "text-white" },
    { to: "/goals-list", icon: faCalendar, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
    { to: "/gratitudes-list", icon: faHeartSolid, label: "Gratitude", bgColor: "bg-orange-700", textColor: "text-white" },
    { to: "/invitations-list", icon: faHandHoldingHeart, label: "Invitation", bgColor: "bg-purple-700", textColor: "text-white" },
    { to: "/issues-list", icon: faHeartSolid, label: "Issues", bgColor: "bg-red-700", textColor: "text-white" },
    { to: "/illness-list", icon: faKitMedical, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
    { to: "/medicine-list", icon: faSyringe, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
    { to: "/meditation-list", icon: faHeartSolid, label: "Meditations", bgColor: "bg-indigo-800", textColor: "text-white" },
    { to: "/memories-list", icon: faCameraRetro, label: "Memories", bgColor: "bg-purple-900", textColor: "text-white" },
    { to: "/missed-opportunities-list", icon: faHeartSolid, label: "Missed Opportunities", bgColor: "bg-red-800", textColor: "text-white" },
    { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly Essentials Plan", bgColor: "bg-yellow-700", textColor: "text-white" },
 
    { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-yellow-400", textColor: "text-red" },
    { to: "/play-list", icon: faHeartSolid, label: "Play/Entertainment", bgColor: "bg-purple-800", textColor: "text-white" },
    { to: "/physical-growth-list", icon: faGaugeHigh, label: "Physical Growth", bgColor: "bg-green-800", textColor: "text-white" },
    { to: "/regrets-list", icon: faTrash, label: "Regrets", bgColor: "bg-gray-800", textColor: "text-white" },
    { to: "/social-activity-list", icon: faPersonBurst, label: "Social Activities", bgColor: "bg-indigo-800", textColor: "text-white" },

    { to: "/study-list", icon: faBookOpen, label: "Study / Readings", bgColor: "bg-indigo-800", textColor: "text-white" },
    { to: "/subscription-list", icon: faHandHoldingHeart, label: "Subscriptions", bgColor: "bg-teal-800", textColor: "text-white" },
    { to: "/sympathy-list", icon: faHeartSolid, label: "Sympathy", bgColor: "bg-green-800", textColor: "text-white" },
    { to: "/thoughts-list", icon: faHeartSolid, label: "Thoughts", bgColor: "bg-blue-800", textColor: "text-white" },
    { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-yellow-800", textColor: "text-white" },
    { to: "/visits-list", icon: faCar, label: "Visits", bgColor: "bg-red-900", textColor: "text-white" },
    { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-gray-900", textColor: "text-white" },
    { to: "/unspecified-list", icon: faFolder, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
    { to: "/attendance-list", icon: faUserCheck, label: "Attendance", bgColor: "bg-orange-600", textColor: "text-white" },
    { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },

    // { to: "/donation-list", icon: faHandHoldingHeart, label: "Donations", bgColor: "bg-yellow-600", textColor: "text-white" },
    // { to: "/bequests-list", icon: faHeartSolid, label: "Bequests", bgColor: "bg-pink-600", textColor: "text-white" },
    // { to: "/essentials-list", icon: faClipboardList, label: "Essentials", bgColor: "bg-gray-200", textColor: "text-gray-800" },
    // { to: "/storage-list", icon: faFileArchive, label: "Storage", bgColor: "bg-gray-200", textColor: "text-gray-800" },
    // { to: "/family-list", icon: faFaceSmile, label: "Family", bgColor: "bg-gray-200", textColor: "text-gray-800" },
    // { to: "/friends-list", icon: faUsers, label: "Friends", bgColor: "bg-gray-200", textColor: "text-gray-800" },
    // { to: "/favourite-list", icon: faHeartSolid, label: "Favorites", bgColor: "bg-gray-200", textColor: "text-gray-800" }
];

const AssociationsHome = () => {
    const navigate = useNavigate();

    const [myHealthCardClicked, setMyHealthCardClicked] = useState(false);
    const [chronicleClicked, setChronicleClicked] = useState(false);
    const [petDashboardClicked, setPetDashboardClicked] = useState(false);

    const handleChronicleClicked = () => {
        setChronicleClicked(!chronicleClicked);
    }
    
    const handleMyHealthCardClicked = () => {
        setMyHealthCardClicked(true);
    }

    const handlePetDashboardClicked = () => {
        setPetDashboardClicked(true);
    }

    const handleMyDiariesClicked = () => {
        navigate("/mydiary-home");
    }

    const handleMyJournalsClicked = () => {
        navigate("/myjournal-home");
    }

    return (
        <MainLayout>
            <div className='flex flex-col'>
                <div className="flex flex-col items-center p-4 bg-gray-700 h-auto mt-12">
                    <p className="text-2xl font-extrabold mb-2 text-white">Chronicles</p>
                    <img 
                        src={lifechroniclesimage} 
                        alt="Life Chronicles" 
                        className="w-full h-64 object-cover mb-6 rounded-lg shadow-lg" 
                    />

                    <div className='flex flex-wrap justify-center gap-4 mt-2 text-sm'>
                        <button  
                            onClick={handleChronicleClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-blue-700 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faCalendarCheck} className="text-red-600 mr-2"/>
                            <span className="text-m font-semibold text-yellow-300">My Chronicles</span>
                        </button>
                        {/* Conditional Chronicle Section */}
                        { chronicleClicked && (
                            <div className="flex flex-col items-center p-4 bg-gray-800">
                                <h1 className="text-xl font-extrabold mb-2 text-gray-800">Life Chronicles</h1>
                                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                                    {categories.map((category, index) => (
                                        <Link 
                                            key={index} 
                                            to={category.to} 
                                            className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                                        >
                                            <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                            <span className="text-m font-semibold flex items-center justify-center text-center">{category.label}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                        
                        <button  
                            onClick={handleMyDiariesClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-blue-700 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faPenFancy} className="text-red-600 mr-2"/>
                            <span className="text-m font-semibold text-yellow-300">My Diaries</span>
                        </button>
                        
                        <button  
                            onClick={handleMyJournalsClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-blue-700 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faFeatherAlt} className="text-red-600 mr-2" />
                            <span className="text-m font-semibold text-yellow-300">My Journals</span>
                        </button>

                        <button  
                            onClick={handleMyHealthCardClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-gray-500 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faHeart} className="text-red-600 mr-2" />
                            <span className="text-m font-semibold text-gray-300">My Health & Wellness Card</span>
                        </button>
                    </div>

                    <div className="flex flex-wrap justify-center gap-4 mt-2 text-sm">
                        <button 
                            onClick={handlePetDashboardClicked}
                            className="w-full rounded-lg bg-gray-500 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-wrap sm:flex-nowrap items-center justify-center p-4"
                        >
                            <div className="flex items-center justify-center space-x-2">
                                <FontAwesomeIcon icon={faDog} className="mr-1 sm:mr-2 text-white-300" />
                                <FontAwesomeIcon icon={faCat} className="mr-1 sm:mr-2 text-black" />
                                <FontAwesomeIcon icon={faHorse} className="mr-1 sm:mr-2 text-red-400" />
                                <FontAwesomeIcon icon={faDove} className="mr-1 sm:mr-2 text-blue-500" />
                                <FontAwesomeIcon icon={faCow} className="mr-1 sm:mr-2 text-white" />
                            </div>
                            <span className="text-m font-semibold text-gray-300 text-center mt-2 sm:mt-0 sm:mx-2">
                            Pet Chronicles Dashboard, Health & Wellness Card
                            </span>
                        </button>
                    </div>
                </div>

                
            </div>
        </MainLayout>
    );
};

export default AssociationsHome;
